<script setup lang="ts">
    import AppMenuNotification from '@/components/menu/AppMenuNotification.vue';
    import AppMenuHelp from '@/components/menu/AppMenuHelp.vue';
    import AppMenuDarkSwitcher from '@/components/menu/AppMenuDarkSwitcher.vue';
    import AppSearch from '@/pages/core/search/AppSearch.vue';
    import AppMenuNav from '@/components/menu/AppMenuNav.vue';
    import { useMenuStore } from '@/stores/menu';
    import { useDisplay, useTheme } from 'vuetify';
    import AppMenuAccountWL from '@/components/menu/AppMenuAccountWL.vue';

    const menuStore = useMenuStore();
    const display = useDisplay();
    const theme = useTheme();

    const navMenuItemsWL = computed(() => menuStore.getNavMenuItemsWL);

    const isDesktopMenu = computed<boolean>(() => display.width.value >= 975);

    watch(isDesktopMenu, (value: boolean) => {
        if (value && menuStore.mobileMenuDrawer) {
            menuStore.mobileMenuDrawer = false;
        }
    });
</script>
<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border" height="47">
            <AppMenuNav v-if="isDesktopMenu" :items="navMenuItemsWL"></AppMenuNav>

            <v-app-bar-nav-icon v-else class="ml-2 ml-md-0" @click="menuStore.mobileMenuDrawer = true">
                <v-icon :color="theme.name.value === 'dark' ? '#b5bac1' : 'tbGreen'" style="background: transparent !important" :icon="mdiMenu" />
            </v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <AppSearch></AppSearch>

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <AppMenuAccountWL></AppMenuAccountWL>

            <AppMenuNotification></AppMenuNotification>

            <AppMenuHelp :items="menuStore.navMenuWLSupportItems"></AppMenuHelp>
        </v-app-bar>
    </v-card>
</template>
<style scoped>
    .v-theme--light .menu-border {
        border-bottom: 1px solid #e0e0e0 !important;
    }

    .v-theme--dark .menu-border {
        border-bottom: 1px solid #404148 !important;
    }

    .v-theme--dark {
        background-color: #1e1f22 !important;
    }
</style>
